"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsAlertPage = void 0;
var _react = _interopRequireDefault(require("react"));
var _dmsbasereact = require("dmsbasereact");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _material = require("@mui/material");
var _GroupTableComponent = require("./DmsAlertComponents/GroupTableComponent");
var _GroupUsersTableComponent = require("./DmsAlertComponents/GroupUsersTableComponent");
var _AlertTableComponent = require("./DmsAlertComponents/AlertTableComponent");
var _ProviderTableComponent = require("./DmsAlertComponents/ProviderTableComponent");
var _MessageTableComponent = require("./DmsAlertComponents/MessageTableComponent");
var _MessageGroupTableComponent = require("./DmsAlertComponents/MessageGroupTableComponent");
var _MessageProviderTableComponent = require("./DmsAlertComponents/MessageProviderTableComponent");
var _TaskTableComponent = require("./DmsAlertComponents/TaskTableComponent");
var _EscalationInstanceTable = require("./DmsAlertComponents/EscalationInstanceTable");
var _EscalationEventTable = require("./DmsAlertComponents/EscalationEventTable");
var _EscalationLevelTable = require("./DmsAlertComponents/EscalationLevelTable");
var _EscalationPolicyTable = require("./DmsAlertComponents/EscalationPolicyTable");
var _SMTPSettingsTable = require("./DmsAlertComponents/SMTPSettingsTable");
var _EmailTemplates = require("./DmsAlertComponents/EmailTemplates");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const DmsAlertPage = () => {
  const tabs = [
  // {
  //     title: intl.get("Alert").d("Alert"),
  //     component: <DmsAlertTable/>
  // },
  // {
  //     title: intl.get("Group").d("Group"),
  //     component: <DmsGroupTable/>
  // },
  // {
  //     title: intl.get("GroupUser").d("Group User"),
  //     component: <DmsGroupUsersTable/>
  // },
  // {
  //     title: intl.get("Provider").d("Provider"),
  //     component: <DmsProviderTable/>
  // },
  // {
  //     title: intl.get("MessageComponent").d("Message Component"),
  //     component: <DmsMessageTable/>
  // },
  // {
  //     title: intl.get("MessageGroup").d("Message Group"),
  //     component: <DmsMessageGroupTable/>
  // },
  // {
  //     title: intl.get("MessageProvider").d("Message Provider"),
  //     component: <DmsMessageProviderTable/>
  // },
  // {
  //     title: intl.get("Task").d("Task"),
  //     component: <DmsTaskTable/>
  // },
  // {
  //     title: intl.get("EscalationLevel").d("Escalation Level"),
  //     component: <DmsEscalationLevelTable/>
  // },
  // {
  //     title: intl.get("EscalationPolicy").d("Escalation Policy"),
  //     component: <DmsEscalationPolicyTable/>
  // },
  // {
  //     title: intl.get("EscalationInstance").d("Escalation Instance"),
  //     component: <DmsEscalationInstanceTable/>
  // },
  // {
  //     title: intl.get("EscalationEvent").d("Escalation Event"),
  //     component: <DmsEscalationEventTable/>
  // },
  // {
  //     title: intl.get("SMTPSettings").d("SMTP Settings"),
  //     component: <SMTPSettingsTable/>
  // },
  {
    title: _reactIntlUniversal.default.get("EmailTemplates").d("Email Templates"),
    component: /*#__PURE__*/_react.default.createElement(_EmailTemplates.EmailTemplates, null)
  }];
  return /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsPage, {
    name: "Alert Components"
  }, /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsAltBox.Card, null, /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsAltBox.Header, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h3",
    sx: {
      fontSize: '1.1rem'
    }
  }, _reactIntlUniversal.default.get("AlertComponents").d("Alert Components"))), /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsAltBox.Body, null, /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsTabber, {
    tabs: tabs
  }))));
};
exports.DmsAlertPage = DmsAlertPage;